import { useSeo } from '@/hooks/useSeo';
import SiteLayout from '@/components/feature/SiteLayout';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryQuickAccess from '@/pages/home/components/CategoryQuickAccess';
import LatestRecommend from '@/pages/home/components/LatestRecommend';
import TopRanking from '@/pages/home/components/TopRanking';
import EditorSpotlight from '@/pages/home/components/EditorSpotlight';
import NewsHighlights from '@/pages/home/components/NewsHighlights';
import BrandIntro from '@/pages/home/components/BrandIntro';

export default function Home() {
  useSeo({
    title: '91大神影视平台 - High-Definition Movie and TV Series Resource Aggregator',
    description:
      '91大神 provides you with the latest movie, TV series and variety show resources, covering a variety of types and themes, making it convenient for users to browse and learn about film and television information online.',
    keywords:
      '91大神, film and television platform, movie resources, TV series, film and television news, online video, film and television recommendations, film and television aggregation',
    canonicalPath: '/',
  });

  return (
    <SiteLayout>
      <HeroCarousel />
      <CategoryQuickAccess />
      <LatestRecommend />
      <TopRanking />
      <EditorSpotlight />
      <NewsHighlights />
      <BrandIntro />
    </SiteLayout>
  );
}